export default "__VITE_ASSET__CDaC5PDG__"